<template>
  <div>
    <div class="billing-usage-total">
      {{ formatCurrency(totalAmount) }}
    </div>
    <div class="billing-usage-breakdown" v-if="usage !== 0">
      {{ usage }} × {{ formatCurrency(price) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BillingUsageSummary',
  props: {
    usage: {
      type: Number,
    },
    price: {
      type: Number,
    },
  },
  computed: {
    totalAmount() {
      return this.usage * this.price;
    },
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
      }).format(value);
    },
  },
};
</script>

<style scoped>
.billing-usage-breakdown {
  font-size: 0.875rem;
  color: #777;
}
</style>
